import { DiamondCollection, CollectionSlider } from "components";
export const HomePage = () => {
  return (
    <div className="home-container bg-gradient w-full h-screen flex items-center flex-row">
      <div className="grid w-full">
        <div className="row-span-3">
          <DiamondCollection />
        </div>

        <div className="row-span-2">
          <CollectionSlider />
        </div>
      </div>
    </div>
  );
};
